angular
  .module('kareo.environment', [
    'kareo.environment.config',
    'ngCookies'
  ])
  .factory('KareoEnvironment', kareoEnvironment);

kareoEnvironment.$inject = ['$cookies', 'ENVIRONMENT_NAME'];
function kareoEnvironment($cookies, ENVIRONMENT_NAME) {
  const isPM = $cookies.get('kareo-pm') === 'true';
  const brand = $cookies.get('kareo-brand');
  return {
    autoAuth: isPM,
    brand,
    environment: ENVIRONMENT_NAME,
    hideChrome: isPM,
    idleTimeout: !isPM,
    isInPm: isPM
  };
}
